// extracted by mini-css-extract-plugin
export var emphasizeQuantity = "_f5-3";
export var flatBottomCorners = "_f5-5";
export var productImage = "_f5-0";
export var quantityContainer = "_f5-2";
export var quantityHeader = "_f5-6";
export var tooltip = "_f5-1";
export var wrapAndEllipsesOverflow = "_f5-4";